import React, { FC } from 'react';
import { Box } from '@material-ui/core';

interface ContainerProps {
  className?: string;
}

const Container: FC<ContainerProps> = (props) => {
  return <Box className={props.className}>{props.children}</Box>;
};

export default Container;
